/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ActivationTaskDto, ActivationTaskUpdateRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ActivationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags activation-controller
   * @name UpdateTask
   * @request PUT:/api/v1/activation/checklist/{taskId}
   */
  updateTask = (taskId: string, data: ActivationTaskUpdateRequest, params: RequestParams = {}) =>
    this.http.request<ActivationTaskDto, any>({
      path: `/v1/activation/checklist/${taskId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateTaskPath = '/v1/activation/checklist/${taskId}'
  static updateTaskMethod = 'PUT'
  /**
   * No description
   *
   * @tags activation-controller
   * @name GetChecklist
   * @request GET:/api/v1/activation/checklist
   */
  getChecklist = (params: RequestParams = {}) =>
    this.http.request<ActivationTaskDto[], any>({
      path: `/v1/activation/checklist`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getChecklistPath = '/v1/activation/checklist'
  static getChecklistMethod = 'GET'
}
